const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="demo-checkbox-labels">
  <label class="demo-checkbox-label">
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/checkbox/checkbox.twig`, undefined, true, false, 3));
                this.echo(`    Unchecked
  </label>
  <label class="demo-checkbox-label">
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/checkbox/checkbox.twig`, new Map([[`checked`, true]]), true, false, 7));
                this.echo(`    Checked
  </label>
</div>
`);
            }

            getTemplateName() {
                return `31408bbc98156c515b9f5d2de7ae5a440db5ea7df5dc4de9edef57c8c656f211`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `31408bbc98156c515b9f5d2de7ae5a440db5ea7df5dc4de9edef57c8c656f211`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '31408bbc98156c515b9f5d2de7ae5a440db5ea7df5dc4de9edef57c8c656f211');

let template = env.loadTemplate('31408bbc98156c515b9f5d2de7ae5a440db5ea7df5dc4de9edef57c8c656f211');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/checkbox/demo/with-label.twig", args: context }
     );
     return rendered;;
};